import React from 'react';
import { PropTypes } from 'prop-types';
import { classNames } from '@checkout-web/web-core';
import styles from './Loading.module.scss';

function getSizeClass(size) {
  switch (size) {
    case 'xs':
      return styles.XSmall;
    case 'sm':
      return styles.Small;
    case 'md':
      return styles.Medium;
    case 'lg':
      return styles.Large;
    case 'xl':
      return styles.XLarge;
    default:
      return styles.Medium;
  }
}

function getInverseClass(inverse) {
  return inverse ? styles.Inverse : styles.NonInverse;
}

function Loading({ size = 'md', inverse = false }) {
  return (
    <svg
      expanded="true"
      height="30px"
      width="90px"
      className={classNames(getSizeClass(size), getInverseClass(inverse))}
    >
      <circle cx="25%" cy="50%" r="5px" className={styles.Dot}>
        <animate
          attributeType="SVG"
          attributeName="r"
          begin="0s"
          dur="1.8s"
          repeatCount="indefinite"
          values="5px;10px;5px;5px"
        />
      </circle>
      <circle cx="50%" cy="50%" r="5px" className={styles.Dot}>
        <animate
          attributeType="SVG"
          attributeName="r"
          begin="0.6s"
          dur="1.8s"
          values="5px;10px;5px;5px"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx="75%" cy="50%" r="5px" className={styles.Dot}>
        <animate
          attributeType="SVG"
          attributeName="r"
          begin="1.2s"
          dur="1.8s"
          repeatCount="indefinite"
          values="5px;10px;5px;5px"
        />
      </circle>
    </svg>
  );
}

Loading.propTypes = {
  size: PropTypes.string,
  inverse: PropTypes.bool
};

Loading.defaultProps = {
  size: 'md',
  inverse: false
};

export default Loading;
